/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetExperimentModel,
  IGetExperimentRequest,
  IMappers,
  IGetExperimentResponse,
  IGetExperimentResponseError,
  TGetExperimentResponse,
} from './types';

const defaultConfig: TGetExperimentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'ab-use',
  pathApi: '/v1/get-experiment/',
  hostType: 'api',
} as TGetExperimentModel;

function createGetExperimentModel(parameters: IGetExperimentRequest): TGetExperimentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetExperimentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetExperimentRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetExperiment<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetExperimentOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetExperimentResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetExperimentModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetExperimentResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetExperimentResponseError);
    }
  }

  return { response, statusCode } as TGetExperimentResponse;
}

export { defaultConfig, createGetExperimentModel, fetchGetExperiment };
